exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#dashboard-page {\n  padding: 40px; }\n  #dashboard-page .ant-card-body {\n    min-height: 200px; }\n\n@media screen and (max-width: 480px) {\n  #dashboard-page {\n    padding: 00px; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/components/Dashboard/dashboard.scss
// module id = 2897
// module chunks = 0